import { render, staticRenderFns } from "./ManagerStatementsForm.vue?vue&type=template&id=64facc42&scoped=true"
import script from "./ManagerStatementsForm.vue?vue&type=script&lang=js"
export * from "./ManagerStatementsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64facc42",
  null
  
)

export default component.exports